<template>
    <div>
        <v-dialog
            v-model="dialog"
            content-class="spillard-dialog spillard-dialog-event"
            :max-width="isSpeedingGraph && isGSensorGraph ? '100%' : '1400px'"
        >
            <v-card v-if="dialog">
                <div class="close" @click="dialog = !dialog">
                    <i class="material-icons">close</i>
                </div>
                <v-card-title>
                    <v-card-title v-if="vehicle" class="v-card__title">
                        <div class="dialog-card-title-left">
                            <div class="icon-slot">
                                <icon class="video-icon" icon="video" :height="20" :width="20" />
                            </div>
                            <div class="reg-number">
                                Reg Number: <span class="text-bold">{{ this.vehicle.driverName || 'Any' }} / {{ this.vehicle.registrationNumber || 'Unknown' }}</span>
                            </div>
                            <div class="make">
                                Make: <span class="text-bold">{{ this.vehicle.manufacturer }}</span>
                            </div>
                            <div class="make">
                                Model: <span class="text-bold">{{ this.vehicle.model }}</span>
                            </div>
                            <div class="make">
                                Engine size: <span class="text-bold">{{ this.vehicle.engineSize }}</span>
                            </div>
                            <div class="make">
                                Year: <span class="text-bold">{{ this.vehicle.yearOfManufacture }}</span>
                            </div>
                        </div>
                        <div class="dialog-card-title-right">
                            <div>
                                <sp-button sp-class="no-padding-right" icon="share-square-solid" text="Share" @click.native="sharedEventDialog = !sharedEventDialog"></sp-button>
                            </div>
                        </div>
                    </v-card-title>
                </v-card-title>
                <v-card-text v-if="event">
                    <v-layout row wrap justify-space-around grid-list-md class="details">
                        <v-flex md12 lg4 :lg6="areBothGraphsPresent">
                            <div class="box">
                                <div class="title">Event details</div>
                                <div class="content">
                                    <v-layout row>
                                        <v-flex xs4>
                                            Type:
                                        </v-flex>
                                        <v-flex xs8 class="text-bold">
                                            {{ eventName }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs4>
                                            Category
                                        </v-flex>
                                        <v-flex xs8 class="text-bold">
                                            {{ eventCategories }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs4>
                                            Classification:
                                        </v-flex>
                                        <v-flex xs8 class="text-bold">
                                            {{ eventClassifications }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs4>
                                            Event date:
                                        </v-flex>
                                        <v-flex xs8 class="text-bold">
                                            {{ date }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs4>
                                            Event location:
                                        </v-flex>
                                        <v-flex xs8 class="text-bold">
                                            {{ event.address ? event.address.label : 'Unknown' }}
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex md6 lg4 v-if="isGSensorGraph">
                            <div class="box">
                                <div class="title">Gsensor graph</div>
                                <div class="content">
                                    <GChart
                                        type="LineChart"
                                        :data="gSensorChartData"
                                        :options="gSensorChartOptions"
                                        style="height: 300px; width: 100%;"
                                    >
                                    </GChart>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex md6 lg4 v-if="isSpeedingGraph">
                            <div class="box">
                                <div class="title">Speed graph</div>
                                <div class="content">
                                    <GChart
                                        class="test"
                                        type="LineChart"
                                        :data="speedChartData"
                                        :options="speedChartOptions"
                                        style="height: 300px; width: 100% !important;"
                                    >
                                    </GChart>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex class="request-video" md12 lg6 v-if="hasAllRoles(['DeviceView','VideoRequests']) && areBothGraphsPresent && checkMediaAccessibilityLicense()">
                            <div class="box">
                                <div class="title">Request video</div>
                                <v-form
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation
                                >
                                    <div class="content">
                                        <div class="inputs-wrapper">
                                            <date-picker
                                                v-model="form.datetime"
                                                :clearable="false"
                                                type="datetime"
                                            />
                                            <sp-select v-model="form.channels" :items="channels" item-value="id" item-text="key" placeholder="Choose channels" multiple :hide-details="true" class="channel-select"></sp-select>
                                            <sp-select v-model="form.duration" :items="durations" item-value="value" item-text="text"></sp-select>
                                        </div>
                                        <div class="flex controls-wrapper">
                                            <v-layout row justify-space-between>
                                                <v-flex md6 align-self-center>
                                                    <sp-switch
                                                        v-model="form.overlay"
                                                        :color="form.overlay ? 'red' : ''"
                                                        :value="form.overlay"
                                                        label="With overlay"
                                                        className="switch--white small-field"
                                                        class="small-field"
                                                    ></sp-switch>
                                                </v-flex>
                                                <v-flex md6>
                                                    <div class="request-button">
                                                        <sp-button sp-class="no-padding-right" icon="settings" text="Request video" @click.native="requestMedia"></sp-button>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </div>
                                </v-form>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-space-around grid-list-md class="visualisation">
                        <v-flex xs8 class="map" v-if="isMap">
                            <div class="box">
                                <div class="title">Event location</div>
                                <div class="content no-padding">
                                    <!-- MAP -->
                                    <here-map v-if="isMap" map-name="eventDialogMap" parent="event"
                                              :lat="event.locations[0].lat"
                                              :lng="event.locations[0].lng"
                                              :zoom="14"
                                    >
                                        <here-info-bubble name="event-dialog-bubble" :lat="event.locations[0].lat" :lng="event.locations[0].lng" :component="vehicleInfoBubble" :data="{
                                            status: 'sleep',
                                            registrationNumber: vehicle.registrationNumber || 'Unknown',
                                            driverName: event.driverName || 'Unknown',
                                            hardwareId: event.hardwareId,
                                            latitude: event.locations[0].lat,
                                            longitude: event.locations[0].lng,
                                        }">
                                            <here-marker auto-tap :lat="event.locations[0].lat" :lng="event.locations[0].lng" :icon="{
                                        bitmap: carMarker,
                                        options: { anchor: { x:16, y:40 } }
                                    }"></here-marker>
                                        </here-info-bubble>
                                    </here-map>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex v-if="hasAllRoles(['EventShowMediaArea']) && checkMediaAccessibilityLicense()" xs4 :xs6="areBothGraphsPresent || !isMap" class="snapshots">
                            <div class="media">
                                <div class="title">Media</div>
                                <div class="content no-padding">
                                    <v-carousel
                                        v-if="mediaList && mediaList.length > 0"
                                        :cycle="false"
                                        :height="!(areBothGraphsPresent || !isMap) ? 310 : 394"
                                        :class="{
                                            'one-item-carousel': mediaList.length === 1,
                                            'many-media-items': mediaList.length > 12,
                                        }"
                                        show-arrows-on-hover
                                    >
                                        <v-carousel-item v-for="item in mediaList" :key="item.id">
                                            <div class="carousel-item-wrapper">
                                                <video-m-p-e-g v-if="item.mimeType === 'video/mp4'" :channel-number="item.channelFlag" :url="item.uri" :tracks="item.overlayUris"></video-m-p-e-g>
                                                <img v-else :src="item.uri" alt="">
                                            </div>
                                        </v-carousel-item>
                                    </v-carousel>
                                    <div class="no-media" :style="!isMap || areBothGraphsPresent? 'height: 394px': ''" v-else>
                                        No media available for this snapshot, try again later
                                    </div>
                                </div>
                            </div>
                        </v-flex>
                    <!-- </v-layout>

                    <v-layout row wrap justify-space-around grid-list-md class="visualisation"> -->
                        <v-flex xs6 v-if="hasAllRoles(['DeviceEventUpdate','EventFileUpload']) && checkMediaAccessibilityLicense()">
                            <div class="box" style="height: inherit">
                                <div class="title">Upload media</div>
                                <div class="content">
                                    <v-layout row>
                                        <v-flex md12>
                                            <div class="dropBox">
                                                <div class="drop-info">
                                                    <div class="drop-image">
                                                        <img src="@/assets/images/icon-drop-here.png" alt="" />
                                                    </div>
                                                    <div class="drop-text">
                                                        Drop image file here or click to select
                                                    </div>
                                                    <div class="drop-input">
                                                        <input type="file" class="file" @change="addFiles" />
                                                        <sp-button sp-class="no-padding-right" small-icon icon="arrow-left" text="Drop file to upload them"></sp-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex md7 class="add-devices">
                                            <div v-if="formUpload.file != null" class="file-list">
                                                <div class="file-list__file"
                                                     :key="`file_${formUpload.file.name}_${formUpload.file.lastModified}`">
                                                    <img src="@/assets/icons/icon-images.svg" width="16">
                                                    {{ formUpload.file.name }}
                                                    <button class="remove-file" @click="clearFile">
                                                        <i class="material-icons">close</i>
                                                    </button>
                                                </div>
                                            </div>
                                        </v-flex>
                                        <v-flex md5>
                                            <div class="upload-file-button">
                                                <sp-button @click.native="uploadMedia" sp-class="no-padding-right" small-icon icon="arrow-left" text="Upload Media"></sp-button>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex class="request-video" xs6 v-if="!(areBothGraphsPresent) && checkMediaAccessibilityLicense() && hasAllRoles(['DeviceView','VideoRequests'])">
                            <div class="box">
                                <div class="title">Request video</div>
                                <v-form
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation
                                >
                                    <div class="content">
                                        <div class="inputs-wrapper">
                                            <date-picker
                                                v-model="form.datetime"
                                                :clearable="false"
                                                type="datetime"
                                            />
                                            <sp-select v-model="form.channels" :items="channels" item-value="id" item-text="key" placeholder="Choose channels" multiple :hide-details="true" class="channel-select"></sp-select>
                                            <sp-select v-model="form.duration" :items="durations" item-value="value" item-text="text"></sp-select>
                                        </div>
                                        <div class="flex controls-wrapper">
                                            <v-layout row justify-space-between>
                                                <v-flex md6 align-self-center>
                                                    <sp-switch
                                                        v-model="form.overlay"
                                                        :color="form.overlay ? 'red' : ''"
                                                        :value="form.overlay"
                                                        label="With overlay"
                                                        className="switch--white small-field"
                                                        class="small-field"
                                                    ></sp-switch>
                                                </v-flex>
                                                <v-flex md6>
                                                    <div class="request-button">
                                                        <sp-button @click.native="requestMedia" sp-class="no-padding-right" icon="settings" text="Request video"></sp-button>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </div>
                                </v-form>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>

        <share-event-dialog v-if="this.event" v-model="sharedEventDialog" :event-id="event.id" :hardware-id="event.hardwareId"></share-event-dialog>
    </div>
</template>

<script>
import HereMap from '@/components/maps/here/HereMap'
import HereInfoBubble from '@/components/maps/here/components/HereInfoBubble'
import HereMarker from '@/components/maps/here/components/HereMarker'
import VehicleInfoBubble from '@/components/atoms/VehicleInfoBubble'
import Select from '@/components/atoms/Select'
import Switch from '@/components/atoms/Switch'
import Button from '@/components/forms/Button'
import { formatDate, splitCamelCase, calculateSpeedOrDistanceUnit } from '@/helpers/Utils'
import moment from 'moment'
import { DeviceApi, DeviceCommandApi, DeviceEventApi, VehicleApi } from '@/api'
import { EventTransformer, VehicleTransformer } from '@/transformers'
import { mapGetters } from 'vuex'

import DatePicker from 'vue2-datepicker'
import '@/assets/scss/datepicker.scss'

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import toast from '@/plugins/izitoast'
import VideoMPEG from '@/components/atoms/VideoMPEG'
import Icon from '@/components/atoms/Icon'
import ShareEventDialog from "@/views/Dashboard/components/ShareEventDialog";

const deviceEventApi = new DeviceEventApi()
const deviceApi = new DeviceApi()
const vehicleApi = new VehicleApi()
const deviceCommandApi = new DeviceCommandApi()

const eventTransformer = new EventTransformer()
const vehicleTransformer = new VehicleTransformer()

export default {
    name: 'EventDialog',
    mounted () {
        this.maxAvailableDate = moment().format('YYYY-MM-DD').toString()

        document.querySelector('.spillard-dialog-event').addEventListener('dragleave', ev => {
            this.dropzone = false
        })

        document.querySelector('.spillard-dialog-event').addEventListener('dragover', ev => {
            ev.preventDefault()
            ev.stopPropagation()

            this.dropzone = true
        })

        document.querySelector('.spillard-dialog-event').addEventListener('drop', ev => {
            ev.preventDefault()
            ev.stopPropagation()

            this.dropped = true
            this.previewFiles(ev.dataTransfer.files)
        })
    },
    components: {
        ShareEventDialog,
        VideoMPEG,
        HereMap,
        HereInfoBubble,
        HereMarker,
        Icon,
        Datetime,
        DatePicker,
        'sp-select': Select,
        'sp-switch': Switch,
        'sp-button': Button
    },
    data () {
        return {
            sharedEventDialog: false,
            nowadate: null,
            valid: false,
            dropped: false,
            dropzone: false,
            isMap: false,
            isGSensorGraph: false,
            isSpeedingGraph: false,
            vehicleInfoBubble: VehicleInfoBubble,
            carMarker: '<svg xmlns="http://www.w3.org/2000/svg" width="31.809" height="40.521" viewBox="0 0 31.809 40.521"><path d="M26.871,4.267a15.764,15.764,0,0,0-11.79-4.2A15.94,15.94,0,0,0,0,15.965c0,11.47,11.2,21.341,14.578,24.129a2.122,2.122,0,0,0,1.325.457,2.034,2.034,0,0,0,1.325-.457A53.023,53.023,0,0,0,25.637,31.5c4.2-5.438,6.261-10.785,6.169-15.812A15.585,15.585,0,0,0,26.871,4.267Z" transform="translate(0 -0.03)" fill="#fff"/><path d="M18.664,41.074C16.151,39.063,5,29.375,5,18.818A13.605,13.605,0,0,1,17.887,5.2h.823A13.557,13.557,0,0,1,32.328,18.636C32.511,29.192,21.177,39.017,18.664,41.074Z" transform="translate(-2.715 -2.838)" fill="#aed51b"/><g transform="translate(6.079 11.699)"><g transform="translate(0 0)"><path d="M16.75,6.593l-2.872.287a.569.569,0,0,0-.479.574.562.562,0,0,0,.526.479h.048l2.872-.287a.569.569,0,0,0,.479-.574A.5.5,0,0,0,16.75,6.593Z" transform="translate(-6.986 -3.432)" fill="#fff"/><path d="M18.954,3.779l-3.685-.957a.978.978,0,0,1-.431-.239L12.54.62A2.7,2.7,0,0,0,11.1.045L7.514,0A4.3,4.3,0,0,0,3.877,1.768l-.622.862-1.532.191A2.062,2.062,0,0,0,0,4.879V6.411A1.473,1.473,0,0,0,1.532,7.895h.383A1.613,1.613,0,0,0,2.489,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.076,2.076,0,0,0,1.1.239,2.256,2.256,0,0,0,2.2-1.675h7.371A1.613,1.613,0,0,0,14.263,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.1,2.1,0,0,0,1.1.287,2.256,2.256,0,0,0,2.2-1.675c1.579-.048,2.345-.574,2.345-1.532v-.67A1.959,1.959,0,0,0,18.954,3.779ZM4.116,8.565A1.292,1.292,0,1,1,5.409,7.273,1.39,1.39,0,0,1,4.116,8.565Zm11.774,0a1.292,1.292,0,1,1,1.292-1.292A1.318,1.318,0,0,1,15.89,8.565Zm3.542-2.2c0,.383-.67.479-1.244.526a2.317,2.317,0,0,0-2.3-1.915,2.1,2.1,0,0,0-1.1.287.661.661,0,0,0-.191.144,2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H6.366a2.411,2.411,0,0,0-2.3-1.915,2.672,2.672,0,0,0-1.1.287c-.048,0-.1.048-.144.1a2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H1.532a.492.492,0,0,1-.526-.479V4.832a.986.986,0,0,1,.862-1.005L3.4,3.587a1.033,1.033,0,0,0,.67-.431l.574-.766A3.344,3.344,0,0,1,7.467,1l3.59.1a1.668,1.668,0,0,1,.814.287l2.25,1.962a2.43,2.43,0,0,0,.862.431l3.685.957a1.021,1.021,0,0,1,.766,1.005Z" transform="translate(0 0.005)" fill="#fff"/></g><path d="M1.54,4.62l1.771-.814,1.2-.479.862-.67,1.2-.766L8.528,1.7h2.824a3.981,3.981,0,0,1,1.388.191c.239.191.766.766.766.766l.814.814a6.083,6.083,0,0,0,1.053.622c.239.1,1.292.335,1.292.335l1.484.383,1.1.383,1.1.909s.144.862.144,1.149-.1.383-.574.574a5.572,5.572,0,0,1-.814.287L18.1,8.449l-.526.862-.766.574a4.4,4.4,0,0,1-.814,0,10.749,10.749,0,0,1-1.34-.718,1.5,1.5,0,0,0-.574-.622A6.883,6.883,0,0,0,12.548,8.4H10.107a10.12,10.12,0,0,0-1.723-.1c-.287.1-1.34.048-1.532.1a1.489,1.489,0,0,0-.526.048C6.278,8.5,5.7,9.6,5.7,9.6a2.579,2.579,0,0,1-.814.383c-.239,0-.718.1-.957-.1s-.67-.622-.67-.622A6.392,6.392,0,0,0,2.928,8.4a6.279,6.279,0,0,1-.718-.144c-.144-.048-.862-.239-.909-.383-.048-.1-.383-.526-.239-.718S1.061,5.1,1.54,4.62Z" transform="translate(-0.535 -0.884)" fill="#fff"/></g></svg>',
            mediaList: [],
            dialog: false,
            vehicle: null,
            event: null,
            eventDetails: null,
            address: '',
            gSensorChartData: [],
            gSensorChartOptions: {
                legend: { position: 'bottom' },
                hAxis: {
                    title: 'Time'
                },
                vAxis: {
                    title: 'Gsensor'
                },
                chartArea: {
                    left: 60,
                    top: 20,
                    width: '85%',
                    height: '80%'
                },
                height: 300,
                backgroundColor: 'transparent',
                annotations: {
                    style: 'line'
                }
            },
            speedChartData: [],
            speedChartOptions: {
                legend: { position: 'bottom' },
                hAxis: {
                    title: 'Time'
                },
                vAxis: {
                    title: 'Speed'
                },
                chartArea: {
                    left: 60,
                    top: 20,
                    width: '75%',
                    height: '80%'
                },
                height: 300,
                backgroundColor: 'transparent',
                annotations: {
                    style: 'line'
                }
            },
            channels: [],
            durations: [
                {
                    'value': 10,
                    'text': '10s'
                },
                {
                    'value': 20,
                    'text': '20s'
                },
                {
                    'value': 30,
                    'text': '30s'
                },
                {
                    'value': 40,
                    'text': '40s'
                },
                {
                    'value': 50,
                    'text': '50s'
                },
                {
                    'value': 60,
                    'text': '1m'
                },
                {
                    'value': 70,
                    'text': '1m 10s'
                },
                {
                    'value': 80,
                    'text': '1m 20s'
                },
                {
                    'value': 90,
                    'text': '1m 30s'
                },
                {
                    'value': 100,
                    'text': '1m 40s'
                },
                {
                    'value': 110,
                    'text': '1m 50s'
                },
                {
                    'value': 120,
                    'text': '2m'
                }
            ],
            form: {
                date: '',
                time: '',
                channels: '',
                overlay: true,
                duration: 10
            },
            formUpload: {
                file: null
            },
            maxAvailableDate: null,
            allowedExtensions: [
                'image/jpeg',
                'image/jpg',
                'video/mp4'
            ]
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        eventId: {
            type: [Object, null]
        }
    },
    computed: {
        ...mapGetters({
            getEventDialog: 'mediaModule/getEventDialog',
            getEventTypes: 'dictionaryModule/getEventTypes',
            getEventClassifications: 'dictionaryModule/getEventClassifications',
            getEventCategories: 'dictionaryModule/getEventCategories',
            getChannels: 'dictionaryModule/getChannels',
            getSpeedUnit: 'authModule/getSpeedUnit'
        }),
        result: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', this.dialog)
            }
        },
        eventName () {
            const event = this.getEventTypes.find((elem) => {
                return elem.id === this.event.eventTypes[0]
            })

            return null == event ? 'Unknown' : this.$t(`eventTypes.${event.key}`)
        },
        eventClassifications () {
            const event = this.getEventClassifications.find((elem) => {
                return elem.id === this.event.eventClassification
            })

            return null == event ? 'Unknown' : splitCamelCase(event.key)
        },
        eventCategories () {
            const event = this.getEventCategories.find((elem) => {
                return elem.id === this.event.eventCategories[0]
            })

            return null == event ? 'Unknown' : splitCamelCase(event.key)
        },
        areBothGraphsPresent () {
            return !this.isGSensorGraph && !this.isSpeedingGraph
        },
        date () {
            return formatDate(this.event.triggerOn)
        }
    },
    watch: {
        value: {
            async handler () {
                this.isMap = false
                this.isGSensorGraph = false
                this.isSpeedingGraph = false
                this.form = {
                    date: '',
                    time: '',
                    datetime: '',
                    channels: '',
                    overlay: true,
                    duration: 10
                }

                if (this.value) {
                    this.$store.state.isOverlayActive = true
                    await this.getEvent(this.eventId)
                    await this.getVehicle(this.event.vehicleId)
                    await this.getDeviceInfo()
                    await this.getMedia()

                    await this.drawSpeedingChart()
                    await this.drawGSensorChart()

                    this.speedChartOptions.vAxis.title = 0 === this.getSpeedUnit ? 'Speed [kph]' : 'Speed [mph]'
                    this.isGSensorGraph = 0 !== this.event.gSensorFrames.length
                    this.isSpeedingGraph = 0 !== this.event.speedPoints.length
                    this.isMap = 0 < this.event.locations.length &&
                        null != this.event.locations[0] &&
                        0 !== this.event.locations[0].lat &&
                        0 !== this.event.locations[0].lng
                    this.$store.state.isOverlayActive = false
                    this.form.datetime = moment(this.event.triggerOn)._d
                    this.dialog = this.value
                }
            }
        },
        dialog (val) {
            if (!val) {
                this.$store.state.eventId = null
                this.event = null
            }

            this.$emit('input', val)
        }
    },
    methods: {
        async drawSpeedingChart () {
            if (0 === this.event.speedPoints.length) {
                return
            }

            await google.charts.load('current', { packages: ['corechart'] })

            this.speedChartData = await new google.visualization.DataTable()
            this.speedChartData.addColumn('number', 'Time')
            this.speedChartData.addColumn({ type: 'string', role: 'annotation' })
            this.speedChartData.addColumn('number', 'Speed')
            this.speedChartData.addColumn('number', 'Speed Limit')
            this.event.speedPoints.forEach((point, index) => {
                this.speedChartData.addRow([
                    index,
                    null,
                    0 === this.getSpeedUnit ? point : calculateSpeedOrDistanceUnit(point, 'mi'),
                    0 === this.getSpeedUnit ? this.event.speedLimit : calculateSpeedOrDistanceUnit(this.event.speedLimit, 'mi')])
            })
        },
        async drawGSensorChart () {
            if (0 === this.event.gSensorFrames.length) {
                return
            }

            await google.charts.load('current', { packages: ['corechart'] })

            this.gSensorChartData = await new google.visualization.DataTable()
            this.gSensorChartData.addColumn('string', 'Time')
            this.gSensorChartData.addColumn({ type: 'string', role: 'annotation' })
            this.gSensorChartData.addColumn('number', 'X')
            this.gSensorChartData.addColumn('number', 'Y')
            this.gSensorChartData.addColumn('number', 'Z')

            this.event.gSensorFrames.forEach((frame, index) => {
                const date = moment(frame.utc).format('YYYY-MM-DD HH:mm:ss').toString()

                this.gSensorChartData.addRow([date, null, frame.x, frame.y, frame.z])
            })
        },
        async getEvent (payload) {
            const response = await deviceEventApi.getDeviceEvent(payload.eventId, payload.hardwareId)
            this.event = eventTransformer.transform(response.payload)

            console.debug('EventDialog::getEvent', this.event)
        },
        async getVehicle (vehicleUuid) {
            const response = await vehicleApi.getVehicle(vehicleUuid)
            this.vehicle = vehicleTransformer.transform(response.payload)
        },
        async getMedia () {
            const response = await deviceEventApi.getDeviceEventMedia(this.event.id, this.event.hardwareId, this.event.id)
            this.mediaList = response.payload.items
        },
        async getDeviceInfo () {
            const response = await deviceApi.getDevice(this.event.hardwareId)

            const channelsFlag = (response.payload.channelFlag >>> 0).toString(2).split('').reverse()

            this.channels = this.getChannels.filter((channel) => {
                return 0 !== channel.id
            }).filter((channel, index) => {
                if (0 === channelsFlag[index] || null == channelsFlag[index]) {
                    return
                }

                return channel.id === Math.pow(2, index)
            })
            this.form.channels = this.channels.map(channel => channel.id)
        },
        async requestMedia () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return
            }
            const date = this.form.datetime

            const response = await deviceCommandApi.requestVideo({
                hardwareId: this.event.hardwareId,
                date: date,
                channels: 0 === this.form.channels.length ? 0 : this.form.channels.reduce((a, b) => a + b, 0),
                videoLengthInSeconds: this.form.duration,
                withOverlay: this.form.overlay,
                eventId: this.event.id
            })

            if (response.isSuccess) {
                toast.success('Media request send')
            }
        },
        clearEvent () {
            this.$store.state.eventId = null
        },
        addFiles (event) {
            this.dropped = true
            this.previewFiles(event.target.files)
        },
        previewFiles (files) {
            if (1 < files.length) {
                toast.error('You can upload only one file.')
                return
            }

            if (!this.allowedExtensions.includes(files[0].type)) {
                toast.error(files[0].type + ' type is not allowed.')
                this.dropped = false
                this.formUpload.file = null
                return
            }
            this.formUpload.file = files[0]
        },
        clearFile () {
            this.formUpload = {
                file: null
            }
        },
        async uploadMedia () {
            if (false === this.dropped) {
                toast.error('You have to upload a file')
                return
            }
            let file = new FormData()
            file.append('file', this.formUpload.file)
            file.append('EventId', this.event.id)
            file.append('HardwareId', this.event.hardwareId)
            const response = await deviceEventApi.uploadMedia(file)

            if (!response.isSuccess) {
                return
            }

            toast.success('Image successfully uploaded')
            this.formUpload.file = null
        }
    }
}
</script>

<style scoped lang="scss">
.details,
.visualisation {
    > .flex {
        margin-bottom: 20px;
        padding: 0 5px;
    }

    .box,
    .media {
        .title {
            background: $secondary;
            color: $font;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px !important;
            margin-bottom: 5px;
            box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.55);
        }
    }

    .box {
        display: flex;
        flex-flow: column;
        height: 100%;

        .content {
            background: $gray;
            padding: 10px 20px;
            font-size: 14px;
            height: calc(100% - 55px);

            .layout {
                padding: 5px 0;
            }
        }
    }

    .media {
        display: flex;
        flex-direction: column;
        height: 345px;
        margin-bottom: 20px;

        .content {
            height: calc(100% - 55px);
        }
    }

    .no-media {
        border: 1px solid #F5F5F5;
        padding: 99px 20px;
        text-align: center;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .dropBox {
        padding: 26px 15px;
    }
}

::v-deep .mx-datepicker {
    margin-bottom: 30px;
    input {
        background: #f5f5f5;
        height: 50px;
    }
}

.test {
    display: flex;
    justify-content: center;
}

.google-event-map {
    width: 100%;
    height: 570px;
}

.close {
    position: absolute;
    top: 14px;
    right: 20px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}

.v-tabs .v-window__container {
    height: auto !important;
}

.modal {
    &__video {
        max-height: 100%;
    }
}

.media {
    .carousel-item-wrapper {
        padding-bottom: 50px;
        height: 100%;
        display: flex;
        justify-content: center;

        img {
            max-width: 100%;
            max-height: 100%;
        }
    }
    .one-item-carousel {
        ::v-deep .v-window-item {
            display: block!important;
        }
    }
    .many-media-items {
        ::v-deep .v-item-group {
            display: flex;
            gap: 15px;
            overflow-x: scroll;
            padding-left: 10px;
            padding-right: 10px;
        }
    }
}

.request-button {
    display: flex;
    justify-content: flex-end;
}

.upload-file-button {
    display: flex;
    justify-content: flex-end;
}

.file-list {
    margin-right: auto;
    &__file {
        display: flex;
        align-items: center;

        img {
            margin-right: 10px;
        }
    }
    .remove-file {
        display: inline-flex;
        align-items: center;
    }
}

.v-card__title {
    display: flex;
    width: 100%;
    align-content: center;
    align-self: center;
    justify-content: space-between;

    .dialog-card-title-left {
        display: flex;
        align-items: center;
    }

    .dialog-card-title-right {
        display: flex;
        align-items: center;
        margin-right: 60px;
    }
}

::v-deep .v-card__text {
    padding: 16px 16px 80px 16px;
}
::v-deep .request-video {
    min-height: 100%;
    .box {
        .title {
            min-height: 50px;
        }
        min-height: 100%;
        height: 100%;
        .v-form {
            min-height: 87.7%;
        }
        .content {
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: space-between;
            .controls-wrapper {
                display: flex;
                align-items: flex-end;
            }
        }
    }
    .datetime-picker {
        border: 1px solid rgba(0,0,0,0.54);
        border-radius: 8px;
        height: 50px;
        margin-bottom: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .datetime-picker .vdatetime-popup__header,
    .datetime-picker .vdatetime-calendar__month__day--selected > span > span,
    .datetime-picker .vdatetime-calendar__month__day--selected:hover > span > span {
        background: $secondary-default;
    }
    .datetime-picker .vdatetime-year-picker__item--selected,
    .datetime-picker .vdatetime-time-picker__item--selected,
    .datetime-picker .vdatetime-popup__actions__button {
        color: $primary;
    }
    .datetime-picker > div {
        height: 10px;
        position: relative;
        width: 100%;
        .vdatetime-popup {
            position: absolute;
            top:15px;
            left:0;
            width: 340px;
            max-width: 340px;
            transform: translateX(-50%)
        }
    }
}
</style>
